import React, { useState, useEffect } from 'react';
import { Card, DatePicker, Select, Table, Tag, Typography, message } from 'antd';
import dayjs from 'dayjs';
import api from '../../api/axios';
import { getBranches } from '../../api/branches';
import useAuthStore from '../../store/authStore';
import { textSorter } from '../../utils/tableSorters';

const { Text } = Typography;

const AbsenceReportTab = () => {
  const { user } = useAuthStore();
  const isBranchManager = user?.role === 'branch_manager';

  const [date, setDate]       = useState(dayjs());
  const [branchId, setBranchId] = useState(isBranchManager ? user?.branch_id : null);
  const [branches, setBranches] = useState([]);
  const [absences, setAbsences] = useState([]);
  const [loading, setLoading]  = useState(false);

  useEffect(() => {
    if (!isBranchManager) {
      getBranches({ per_page: 100 }).then(res => setBranches(res.data.data || [])).catch(() => {});
    }
  }, []);

  useEffect(() => { fetchAbsences(); }, [date, branchId]);

  const fetchAbsences = async () => {
    setLoading(true);
    try {
      const res = await api.get('/reports/today-absences', {
        params: { date: date.format('YYYY-MM-DD'), branch_id: branchId || undefined },
      });
      setAbsences(res.data || []);
    } catch {
      message.error('Devamsızlıklar yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  // Tek gunluk liste, tamami bellekte - istemci siralayicilari dogru calisir.
  const columns = [
    {
      title: 'Öğrenci',
      dataIndex: 'student_name',
      sorter: textSorter('student_name'),
      render: (name, r) => (
        <a href={`/students/${r.student_id}`} className="font-medium text-blue-500 hover:underline">
          {name}
        </a>
      ),
    },
    {
      title: 'Derslik',
      dataIndex: 'classroom_name',
      sorter: textSorter('classroom_name'),
      render: v => <Tag>{v}</Tag>,
    },
    {
      title: 'Saat',
      dataIndex: 'start_time',
      width: 80,
      sorter: textSorter('start_time'),
      render: v => v?.slice(0, 5),
    },
    {
      title: 'Durum',
      width: 110,
      render: () => <Tag color="red">Gelmedi</Tag>,
    },
  ];

  return (
    <div>
      <div className="flex gap-3 mb-4 flex-wrap items-center">
        <DatePicker
          value={date}
          onChange={d => d && setDate(d)}
          format="DD.MM.YYYY"
          allowClear={false}
          style={{ width: 160 }}
        />
        {!isBranchManager && (
          <Select
            placeholder="Tüm şubeler"
            allowClear
            style={{ width: 200 }}
            value={branchId}
            onChange={v => setBranchId(v ?? null)}
            options={branches.map(b => ({ value: b.id, label: b.name }))}
          />
        )}
        <Text type="secondary" className="text-sm">
          {!loading && (absences.length > 0
            ? `${absences.length} devamsız öğrenci`
            : 'Devamsız öğrenci yok')}
        </Text>
      </div>

      <Table
        dataSource={absences}
        columns={columns}
        rowKey="attendance_id"
        loading={loading}
        size="small"
        pagination={{ pageSize: 20, hideOnSinglePage: true }}
        locale={{ emptyText: 'Bu tarihte devamsız öğrenci yok veya yoklama alınmamış.' }}
      />
    </div>
  );
};

export default AbsenceReportTab;
